import { getCamelOrSnakeCase } from '@/helpers';

export default function equalFilter(key, value) {
    return (item) => {
        return getCamelOrSnakeCase(item, key) == value;
    };
}
